import React from "react";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Module } from "../../layouts";

import ModalTitle from "./modal-title";

type LoadingModalProps = {
  resolved: number;
  total: number;
};

export default function LoadingModal(props: LoadingModalProps) {
  return (
    <div className="text-center">
      <ModalTitle>Loading</ModalTitle>
      <Module>
        <p>Loading animation frames</p>
      </Module>
      <div className="text-5xl text-gray-500">
        <FontAwesomeIcon icon={faSpinner} spin />
      </div>
      <Module>
        <p>
          {props.resolved} of {props.total}
        </p>
      </Module>
    </div>
  );
}
